import { CustomTableSortItems } from 'commons/components/table/sort/custom-table-sorting.model';
import { getI18nCodeLanguage, i18n } from 'core/i18n/i18n';

const appCollationLocale = (): string | undefined => (i18n.language ? getI18nCodeLanguage(i18n.language) : undefined);

export const sortByStringField = <TField extends string, TRow extends Record<TField, string>>(
    rows: TRow[],
    sortItems: CustomTableSortItems,
    field: TField
): TRow[] => {
    const order = sortItems[field];

    if (!order || order === 'default') {
        return rows;
    }

    const direction = order === 'desc' ? -1 : 1;
    const locale = appCollationLocale();

    return rows.toSorted((first, second) => direction * first[field].localeCompare(second[field], locale));
};

export const sortAndJoin = (values: string[], separator = ', '): string => {
    const locale = appCollationLocale();
    return values.toSorted((left, right) => left.localeCompare(right, locale)).join(separator);
};
